export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const DOMAIN_PATRNER = "http://clbnhaythanhxuan.com";
